/* eslint-disable import/no-unresolved */
import { useQuery, useReactiveVar } from '@apollo/client';
import { tenantIdVar } from 'Apollo/config';

import {
    GET_FILES_FOR_PROJECT,
    GET_RECON_FUNCTIONS,
    GET_SUB_PROJECTS,
} from 'Apollo/Queries/DataRecon/DataConfiguration';

/* apollo query to fetch files of the selected project */
export const GetFilesForProject = projectId => {
    const tenantId = useReactiveVar(tenantIdVar);
    const {
        data,
        loading,
        error,
        fetchMore,
    } = useQuery(GET_FILES_FOR_PROJECT, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                projectId: Number(projectId),
                pageSize: 8,
                pageNumber: 1,
                tenantId,
            },
        },
    });
    if (loading) {
        return {
            isFileLoading: loading,
        };
    }
    let getFilesForProject = [];
    if (!loading && !error) {
        getFilesForProject = data ? data.getFilesForProject : [];
    }

    const handleClick = () => {
        fetchMore({
            query: GET_FILES_FOR_PROJECT,
            variables: {
                input: {
                    projectId: Number(projectId),
                    pageSize: 8,
                    pageNumber: 1,
                },
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) {
                    return previousResult;
                }
                return {
                    ...previousResult,
                    getFilesForProject: [
                        ...previousResult.getFilesForProject,
                        ...fetchMoreResult.getFilesForProject,
                    ],
                };
            },
        });
    };
    return {
        getFilesForProject,
        error,
        handleClick,
        isFileloading: loading,
    };
};

/* apollo query to fetch recon functions */
export const GetReconFunctions = () => {
    const { data, loading, error } = useQuery(GET_RECON_FUNCTIONS, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                pageSize: 10,
                pageNumber: 1,
                isPreview: false,
            },
        },
    });

    let reconFunctions = [];
    if (!loading && !error) {
        reconFunctions = data ? data.getReconFunctions : [];
    }
    return {
        reconFunctions,
        isFunctionLoading: loading,
    };
};

/* apollo query to fetch sub projects of selected project */
export const GetSubProjects = projectId => {
    const { data, loading, error } = useQuery(GET_SUB_PROJECTS, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                pageSize: 10,
                pageNumber: 1,
                projectId: Number(projectId),
            },
        },
    });
    let subProjects = [];
    if (!loading && !error) {
        subProjects = data ? data.getChildProjectsConfiguration : [];
    }
    return {
        subProjects,
        isSubProjectLoading: loading,
    };
};
